import { Component, OnInit, Input, ViewChild, Output, EventEmitter, OnChanges, SimpleChanges, ElementRef, Renderer2, ChangeDetectionStrategy } from '@angular/core';
import { Questions } from 'src/app/common-class/questions';
import { Answers } from 'src/app/common-class/answers';
import { Group } from 'src/app/common-class/pages';
import { SurveyMessages } from 'src/app/common-class/survey-messages';
import { ParticipationDataService } from 'src/app/_services/participation-data.service';
declare var $: any;

@Component({
  selector: 'app-drop-down',
  templateUrl: './drop-down.component.html',
  styleUrls: ['./drop-down.component.css'],
  //changeDetection: ChangeDetectionStrategy.OnPush
})
export class DropDownComponent implements OnInit, OnChanges {

  @Input() JsonData: string;
  @Input() isMandatoryUpfront: boolean;
  @Input() isDisplayQno: boolean;
  @Input() isDisplaySubQno: boolean;
  @Input() isMDD: boolean;
  @Input() isOtherControl: boolean;
  @Input() DropDown:string;
  @Input() isDemographics: boolean;
  @Input() isMobile: boolean;
  @Input() isGrid:boolean;
  @Input() isNonSearchable:boolean;
  @Input() dropDownlength:number;
  @Input() isNewParticipationButton: boolean;
  @Input() isStandAlone: boolean;
  @Input() group: Group;
  @Input() isAnySubQMandatory:boolean;
  @Output() ChangeAnswersData: EventEmitter<Questions> = new EventEmitter<Questions>();
  questions: Questions;
  answer: Answers;
  questionsQDL: Questions;
  answerImagesLength: number;
  isFormSubmit: boolean = false;
  isFormSubmitSub: any;
  selectedQDLValue: number;
  isPreview: boolean;
  dropDownCount:number;
  isAriaRequired: boolean;
  checkDrillDown: number = 0;
  prevValue: any;
  isNewParticipation: boolean;
  surveyFormat: number;
  newParticipationBtnText: string;
  showNewParticipationButton: boolean;
  isAnsChange: boolean = false;
  isIEOrEdge: boolean = false;
  isOtherQuestion: boolean = false;
  resetPageSub: any;
  MDDdropDownCount:number;
  Nomatchfound: string;
  surveyMessages: SurveyMessages;

  ngOnChanges(changes: SimpleChanges) {

    let change = changes['JsonData'];

    let curVal = JSON.stringify(change.currentValue);
    let preVal = JSON.stringify(change.previousValue);

    if (curVal != preVal && preVal != undefined) {
      this.questions = JSON.parse(this.JsonData);
    }

  }
  constructor(private service: ParticipationDataService,private el: ElementRef,private renderer: Renderer2) {
  }

  ngOnInit() {
    if (this.questions == null) {
      this.questions = JSON.parse(this.JsonData);
      this.surveyMessages= this.service.getSurveyMessages();
      let updateItem = this.questions.Answers.find(
        e => e.hasImage && e.AnswerImages.length == 2);

      if(this.questions.Answers.filter(e => e.isOther).length > 0){
        this.isOtherQuestion = true;
      }

      if(this.questions.population_type == 3)
      {
        this.isAnsChange = true;
      }

      if (updateItem != null && updateItem != undefined) {
        this.answerImagesLength = 2;

        if (this.questions.population_type == 3) {
          if (this.questions.selectAnsValue != updateItem.value_id) {
            this.answerImagesLength = 0;
          }
        }

      } else {
        updateItem = this.questions.Answers.find(
          e => e.hasImage && e.AnswerImages.length == 1);

        if (updateItem != null && updateItem != undefined) {
          this.answerImagesLength = 1;

          if (this.questions.population_type == 3) {
            if (this.questions.selectAnsValue != updateItem.value_id) {
              this.answerImagesLength = 0;
            }
          }
        }
      }

      if (this.questions.answer_style == 1 && this.questions.RotateIndex == 0 && this.questions.Answers != null) {
        this.RandomAnswerHandling();
      }

      if (this.questions.selectAnsValue >= 0) {
        let updateItem = this.questions.Answers.find(
          e => e.value_id == this.questions.selectAnsValue);
        if (updateItem == null && updateItem == undefined) {
          this.questions.selectAnsValue = -1;
        }else if(updateItem.isQuotaDisable){
          this.questions.selectAnsValue = -1;
        }
      }
      else {
        this.questions.selectAnsValue = -1;
      }
      this.isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
    }
    if(this.isGrid){
      this.dropDownCount = this.service.getMDDdropDownCount();
    }else{
      this.dropDownCount = this.service.getdropDownCount();
    }
    this.MDDdropDownCount = this.service.getMDDdropDownCount();
    // Subscibe To Form Submit/Next Event ( Event is fired when mandatory is not satisfied )
    this.isFormSubmitSub = this.service.emitFormSubmitEvent.subscribe((data) => {
      this.isFormSubmit = data;
    });

    this.isPreview = this.service.GroupType.toUpperCase() == 'PREVIEW';

    this.isAriaRequired = (this.questions.mandatory && (this.isMandatoryUpfront || this.questions.isMandatoryStar)) || (this.questions.mandatory && this.isFormSubmit && this.questions.isMandatoryInvalid)

    this.isNewParticipation = this.service.isNewParticipation;
    this.surveyFormat = this.service.surveyFormat;
    this.newParticipationBtnText = this.service.newParticipationBtnText;
    this.showNewParticipationButton = this.isNewParticipationButton && (!this.service.isAutoScroll || this.questions.population_type==3);
    this.Nomatchfound= this.service.getSurveyMessages().Participation_Nomatchfound;
  }

  ngAfterViewInit(){
    $('.drill-down-list-itemMessage_'+this.questions.UniqueNumber).hide();
    setTimeout(() => {
      let element = this.el.nativeElement.querySelector("input.drill-down-input");

      if(element == null){
        return;
      }

      if (element.value) {
        this.renderer.addClass(element, "no-search-icon");
      }
      else {
        this.renderer.removeClass(element, "no-search-icon");
      }
    },1);

    // $(document).click(function () {
    //   if (!$(event.target).parents().hasClass('drill-down-search')) {
    //     $('.drill-down-search').removeClass('showDrillList');
    //   }
    // });
    setTimeout(() => {
      let element1 = this.el.nativeElement.querySelector(".custom-select-wrapper");
      $('.drill-down-list-itemMessage_' + this.questions.UniqueNumber).css('width', $(element1).width() + 'px');
    }, 1);
    this.resetPageSub = this.service.emitResetPageEvent.subscribe((data) => {
      if (data) {
        this.isAnsChange = false;
        let element = this.el.nativeElement.querySelector("input.drill-down-input");
        this.renderer.removeClass(element, "no-search-icon");
      }
    });
  }

  ngOnDestroy(){
    this.isFormSubmitSub.unsubscribe();
    if (this.resetPageSub) {
      this.resetPageSub.unsubscribe();
    }
  }

  RandomAnswerHandling() {
    let currentIndex = this.questions.Answers.length, temporaryValue, randomIndex;
    let updateItem = this.questions.Answers.find(e => e.isOther);
    if (updateItem != undefined && updateItem != null) {
      currentIndex -= 1;
    }

    // While there remain elements to shuffle...
    while (0 !== currentIndex) {
      // Pick a remaining element...
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;

      // And swap it with the current element.
      temporaryValue = this.questions.Answers[currentIndex];
      this.questions.Answers[currentIndex] = this.questions.Answers[randomIndex];
      this.questions.Answers[randomIndex] = temporaryValue;
    }
  }

  GetRBClass(DispAnsCol: number) {
    switch (DispAnsCol) {
      case 1:
        return 'radio-hrb_1'
        break;

      case 2:
        return 'radio-hrb_2'
        break;

      case 3:
        return 'radio-hrb_3'
        break;

      case 4:
        return 'radio-hrb_4'
        break;

      case 5:
        return 'radio-hrb_5'
        break;

      default:
        return 'radio-hrb'
        break;
    }
  }

  GetMandatoryState(): boolean {
    if (this.questions != null) {
      return this.questions.mandatory;
    }
  }

  SelectedValue(event: any, isSearchableDD: boolean = false, curVal: number = -1) {

      let value = event.target.value;

      if (isSearchableDD) {
        value = curVal.toString();
      }

      if (value === "-1") {

        if (this.questions.Answers.find(e => e.selectdId == 1) != undefined) {
          this.questions.Answers.find(e => e.selectdId == 1).ControlAns = null;
          this.questions.Answers.find(e => e.selectdId == 1).selectdId = 0;
        }

        this.questions.isOtherAnswer = false;
        this.questions.selectAnsValue = -1;
        this.questions.AnswerID = 0;
        this.questions.pageto = 0;
        this.questions.AnswerText = null;
      } else {
        for (let i = 0; i < this.questions.Answers.length; i++) {
          if (value == this.questions.Answers[i].value_id && !this.questions.Answers[i].isADLHide) {
            event.selectdId = 1;
            //this.questions.Answers[i] = answer;
            this.questions.Answers[i].selectdId = 1;
            this.questions.Answers[i].ControlAns = this.questions.Answers[i].value_text;
            this.questions.AnswerID = this.questions.Answers[i].ms_id;
            this.questions.selectAnsValue = this.questions.Answers[i].value_id;
            this.questions.AnswerText = this.questions.Answers[i].value_text;
            this.questions.pageto = this.questions.Answers[i].pageto;
            this.questions.otherAnswer = null;

            if (this.questions.isSoftRequired) {
              this.questions.isSoftRequiredHandle = true;
            }

            if (this.questions.Answers[i].isOther) {
              this.questions.isOtherAnswer = true;
              let id = this.questions.UniqueNumber + '_txt_other';
              let control = document.getElementById(id);

              setTimeout(function () {
                control.focus();
              }, 0);
            }
            else {
              this.questions.isOtherAnswer = false;
            }
          }
          else {
            this.questions.Answers[i].ControlAns = null;
            this.questions.Answers[i].selectdId = 0;
          }
        }
      }
      this.UpdateQuestionsData(this.questions);
      //this.ChangeAnswersData.emit(this.questions);
  }


  findIndexToUpdate(answer) {
    return answer === this;
  }

  GetQuestionsString(question: Questions, index: number): string {
    return JSON.stringify(question);
  }

  UpdateQuestionsData(question: Questions) {
    if(this.questions.isOtherAnswer || this.showNewParticipationButton)
    {
      this.isAnsChange = true;
    }
    this.ChangeAnswersData.emit(question);
  }

  getHiddenAnswer(answers:Answers)
  {
    return !answers.isHide;
  }

  setDrillDownValue(event: any, question: Questions, self, curVal: number) {
    self.SelectedValue(event, true, curVal);
    //self.nextQuestion(event);
    let element = this.el.nativeElement.querySelector("input.drill-down-input");
    if (element.value) {
      this.renderer.addClass(element, "no-search-icon");
    }
    else {
      this.renderer.removeClass(element, "no-search-icon");
    }
  }

  showDDList(event) {

    if ($(event.target).parents().hasClass('showDrillList')) {
      $(event.target).closest('.drill-down-search').removeClass('showDrillList');
      $(event.target).closest('.drill-down-input').attr("aria-expanded","false");
    }else{
      $('.drill-down-search').removeClass('showDrillList');
      $(event.target).closest('.drill-down-search').addClass('showDrillList');
      $(event.target).attr("aria-expanded","true");
      $(event.target).closest('.drill-down-search').find('.drill-down-input').focus();
      $(event.target).closest('.drill-down-search').find('.drill-down-list-item').show();
    }
  }

  selectDDListItem(event, question: Questions) {
    var self = this;
    $(event.target).closest('.drill-down-search').find('.drill-down-input').val('');
    $(event.target).closest('.drill-down-search').find('.drill-down-list-item').each(function () {
      $(this).html($(this).attr('ogListValue'));
      $(this).show();
      $(this).html(self.highlight($(this).html(), ''));
    });
    let itemText = $(event.target).attr('ogListValue');
    let itemValue = $(event.target).attr('list-value');
    $(event.target).closest('.drill-down-search').find('select').val(itemValue);
    $(event.target).closest('.drill-down-search').find('.drill-down-input').val(itemText);
    $(event.target).closest('.drill-down-search').removeClass('showDrillList');
    $(event.target).closest('.drill-down-input').attr("aria-expanded","false");
    self.checkDrillDown = 1;
    self.setDrillDownValue(event, question, self, itemValue);
    self.nextQuestion(event.target);
  }

  setDDListItem(event, question: Questions) {
    var self = this;
    setTimeout(function () {
      if (self.checkDrillDown == 0 && self.checkDrillDown != undefined) {
        const ddSearchValue = $(event.target).val().toLowerCase();
        // const currentInput = $(this);
        if (ddSearchValue !== '') {
          $(event.target).closest('.drill-down-search').find('.drill-down-list-item').each(function () {
            $(this).html($(this).attr('ogListValue'));
            if (ddSearchValue === $(this).text().toLowerCase()) {
              $(event.target).val($(this).attr('ogListValue'));
              // $(event.target).closest('.drill-down-search').removeClass('showDrillList');
              $(event.target).attr("aria-expanded","false");
              const itemValue = $(this).attr('list-value');
              $(this).closest('.drill-down-search').find('select').val(itemValue);
              self.setDrillDownValue(event, question, self, itemValue);
              return false;
            } else {
              $(event.target).val('');
              $(this).closest('.drill-down-search').find('select').val('0');
              self.questions.AnswerText = null;
              self.setDrillDownValue(event, question, self, -1);
            }
          });
        } else {
          self.questions.AnswerText = null;
          self.setDrillDownValue(event, question, self, -1);
        }
      }
    }, 0);
    // $(event.target).closest('.drill-down-search').removeClass('showDrillList');
    $(event.target).attr("aria-expanded","false");
    setTimeout(function () {
    $('.drill-down-list-itemMessage_'+self.questions.UniqueNumber).hide();
  }, 1);
  }

  filterDDSearch(event) {
    var self = this;
    var keyCode = event.keyCode || event.which;
    if(keyCode == 13 || keyCode == undefined){
      event.preventDefault();
      $(event.target).blur();
      setTimeout(function (){
        $(event.target).closest('.drill-down-search').removeClass('showDrillList');
        $(event.target).attr("aria-expanded","false");
      }, 100);
    }
    setTimeout(function () {
      var keyCode = event.keyCode || event.which;
      if(keyCode !== 9){
        $(event.target).closest('.drill-down-search').addClass('showDrillList');
        $(event.target).attr("aria-expanded","true");
        if(keyCode == 40){
          event.preventDefault();
          if($(event.target).closest('.drill-down-search').find('select').val() <= 0 || $(event.target).closest('.drill-down-search').find('select').val() == parseInt($(event.target).closest('.drill-down-search').find('.drill-down-list .drill-down-list-item:visible:last').attr('list-value'))){
            $(event.target).closest('.drill-down-search').find('select').val($(event.target).closest('.drill-down-search').find('.drill-down-list .drill-down-list-item:visible:first').attr('list-value'));
            $(event.target).closest('.drill-down-search').find('.currentActiveDDITem').removeClass('currentActiveDDITem');
            $(event.target).closest('.drill-down-search').find('.drill-down-list .drill-down-list-item:visible:first').addClass('currentActiveDDITem');
            $(event.target).val($(event.target).closest('.drill-down-search').find('select option:selected').text());
          } else {
            var nextElement = $(event.target).closest('.drill-down-search').find('.currentActiveDDITem').nextAll('.drill-down-list-item:visible:first');
            if(nextElement.length > 0){
              $(event.target).closest('.drill-down-search').find('select').val(parseInt(nextElement.attr('list-value')));
              $(event.target).val($(event.target).closest('.drill-down-search').find('select option:selected').text());
              $(event.target).closest('.drill-down-search').find('.currentActiveDDITem').removeClass('currentActiveDDITem');
              nextElement.addClass('currentActiveDDITem');
            } else {
              nextElement = $(event.target).closest('.drill-down-search').find('.currentActiveDDITem');
              $(event.target).closest('.drill-down-search').find('select').val(parseInt(nextElement.attr('list-value')));
              $(event.target).val($(event.target).closest('.drill-down-search').find('select option:selected').text());
              $(event.target).closest('.drill-down-search').find('.currentActiveDDITem').removeClass('currentActiveDDITem');
              nextElement.addClass('currentActiveDDITem');
            }
          }

          var elementPos = $(event.target).closest('.drill-down-search').find('.currentActiveDDITem').offset().top;
          var elementPosWithHt = $(event.target).closest('.drill-down-search').find('.currentActiveDDITem').offset().top + $(event.target).closest('.drill-down-search').find('.currentActiveDDITem').outerHeight();
          var scrollableDivPos = $(event.target).closest('.drill-down-search').find('.drill-down-list').offset().top;
          var scrollableDivPosWithHt = $(event.target).closest('.drill-down-search').find('.drill-down-list').offset().top + $(event.target).closest('.drill-down-search').find('.drill-down-list').outerHeight();

          if(elementPosWithHt > scrollableDivPosWithHt){
            $(event.target).closest('.drill-down-search').find('.drill-down-list').scrollTop($(event.target).closest('.drill-down-search').find('.drill-down-list').scrollTop() + (elementPosWithHt - scrollableDivPosWithHt));
          } else if(elementPos < scrollableDivPos) {
            $(event.target).closest('.drill-down-search').find('.drill-down-list').scrollTop($(event.target).closest('.drill-down-search').find('.drill-down-list').scrollTop() - (scrollableDivPos - elementPos));
          }

        } else if(keyCode == 38) {
          event.preventDefault();
          if($(event.target).closest('.drill-down-search').find('select').val() <= 0 || $(event.target).closest('.drill-down-search').find('select').val() == parseInt($(event.target).closest('.drill-down-search').find('.drill-down-list .drill-down-list-item:visible:first').attr('list-value'))){
            $(event.target).closest('.drill-down-search').find('select').val($(event.target).closest('.drill-down-search').find('.drill-down-list .drill-down-list-item:visible:last').attr('list-value'));
            $(event.target).closest('.drill-down-search').find('.currentActiveDDITem').removeClass('currentActiveDDITem');
            $(event.target).closest('.drill-down-search').find('.drill-down-list .drill-down-list-item:visible:last').addClass('currentActiveDDITem');
            $(event.target).val($(event.target).closest('.drill-down-search').find('select option:selected').text());
          } else {
            // $(event.target).closest('.drill-down-search').find('select').val(parseInt($(event.target).closest('.drill-down-search').find('select').val()) - 1);
            // $(event.target).val($(event.target).closest('.drill-down-search').find('select option:selected').text());

            var prevElement = $(event.target).closest('.drill-down-search').find('.currentActiveDDITem').prevAll('.drill-down-list-item:visible:first');
            if(prevElement.length > 0){
              $(event.target).closest('.drill-down-search').find('select').val(parseInt(prevElement.attr('list-value')));
              $(event.target).val($(event.target).closest('.drill-down-search').find('select option:selected').text());
              $(event.target).closest('.drill-down-search').find('.currentActiveDDITem').removeClass('currentActiveDDITem');
              prevElement.addClass('currentActiveDDITem');
            } else {
              prevElement = $(event.target).closest('.drill-down-search').find('.currentActiveDDITem');
              $(event.target).closest('.drill-down-search').find('select').val(parseInt(prevElement.attr('list-value')));
              $(event.target).val($(event.target).closest('.drill-down-search').find('select option:selected').text());
              $(event.target).closest('.drill-down-search').find('.currentActiveDDITem').removeClass('currentActiveDDITem');
              prevElement.addClass('currentActiveDDITem');
            }
          }
          var elementPos = $(event.target).closest('.drill-down-search').find('.currentActiveDDITem').offset().top;
          var elementPosWithHt = $(event.target).closest('.drill-down-search').find('.currentActiveDDITem').offset().top + $(event.target).closest('.drill-down-search').find('.currentActiveDDITem').outerHeight();
          var scrollableDivPos = $(event.target).closest('.drill-down-search').find('.drill-down-list').offset().top;
          var scrollableDivPosWithHt = $(event.target).closest('.drill-down-search').find('.drill-down-list').offset().top + $(event.target).closest('.drill-down-search').find('.drill-down-list').outerHeight();

          if(elementPosWithHt > scrollableDivPosWithHt){
            $(event.target).closest('.drill-down-search').find('.drill-down-list').scrollTop($(event.target).closest('.drill-down-search').find('.drill-down-list').scrollTop() + (elementPosWithHt - scrollableDivPosWithHt));
          } else if(elementPos < scrollableDivPos) {
            $(event.target).closest('.drill-down-search').find('.drill-down-list').scrollTop($(event.target).closest('.drill-down-search').find('.drill-down-list').scrollTop() - (scrollableDivPos - elementPos));
          }
        } else {
          $(event.target).closest('.drill-down-search').find('.currentActiveDDITem').removeClass('currentActiveDDITem');
          $(event.target).closest('.drill-down-search').find('select').val('-1');
          const ddSearchValue = $(event.target).val().toLowerCase();
          if (ddSearchValue !== '') {
            var isShowmessage=false;
            $(event.target).closest('.drill-down-search').find('.drill-down-list-item').each(function () {
              $(this).html($(this).attr('ogListValue'));
              if ($(this).text().toLowerCase().indexOf(ddSearchValue) !== -1) {
                $(this).show();
                $(this).html(self.highlight($(this).html(), ddSearchValue));
                isShowmessage=true;
              } else {
                $(this).hide();
              }
            });
            if(!isShowmessage){
              $('.drill-down-list-itemMessage_'+self.questions.UniqueNumber).show();
            }else{
              $('.drill-down-list-itemMessage_'+self.questions.UniqueNumber).hide();
            }

            if ($(event.target).closest('.drill-down-search').find('.drill-down-list-item:visible').length === 0) {
              $(event.target).closest('.drill-down-search').removeClass('showDrillList');
              $(event.target).attr("aria-expanded","false");
            } else {
              $(event.target).closest('.drill-down-search').addClass('showDrillList');
              $(event.target).attr("aria-expanded","true");
            }
          } else {
            $('.drill-down-list-itemMessage_'+self.questions.UniqueNumber).hide();
            $(event.target).closest('.drill-down-search').find('.drill-down-list-item').show();
            $(event.target).closest('.drill-down-search').find('.drill-down-list-item').each(function () {
              $(this).html($(this).attr('ogListValue'));
            });
          }
          if($(event.target).val() != self.prevValue){
            self.checkDrillDown = 0;
          } else {
            self.checkDrillDown = 1;
          }
        }

      } else {
        $(event.target).closest('.drill-down-search').removeClass('showDrillList');
        $(event.target).attr("aria-expanded","false");
      }
    }, 1);
  }

  setPrevValue(event){
    this.prevValue = $(event.target).val();
  }

  highlight(s, search) {
    return s.replace(new RegExp(
      search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'), 'gi'
    ), '<b>$&</b>');
  }

  nextQuestion(event) {
    if (this.isNewParticipation && (this.surveyFormat == 1 || this.surveyFormat == 2) && this.service.isAutoScroll && !(!this.service.isMobile&&this.questions.qtype == "RW"&&this.questions.qsubtype==2) && !(this.isDemographics && this.dropDownlength != 1)) {
      if (this.questions.selectAnsValue != 0) {
        // var nextbtnLength = $(event).closest('.active-ques').nextAll('.inactive-ques').has('.question-data').length;

        // if (nextbtnLength > 0) {
        //   var elemPosition = $(event).closest('.active-ques').nextAll('.inactive-ques').has('.question-data').eq(0).offset().top;
        //   $('html,body').animate({
        //     scrollTop: (elemPosition - $(window).height() / 3)
        //   }, 400);
        // } else {
        //   var scrollVal = $('.tblPageFooter').offset().top;
        //   $('html,body').animate({
        //     scrollTop: scrollVal
        //   }, 400);
        // }

        // $(event).closest('.main-ques-cont').find('.ques-response-btn-div').hide();


        if (this.isStandAlone) {
          var nextbtnLength = $(event).closest('.active-ques').nextAll('.inactive-ques').has('.question-data').length;
          if(this.questions.isMatrixQuestion){
            var MatrixelemPosition;
            MatrixelemPosition = $(event).closest('.matrix-mobile-subQ_' + this.group.Matrix_id).nextAll('.matrix-mobile-subQ_' + this.group.Matrix_id)
            //MatrixelemPosition = $(event).nextAll('.matrix-mobile-subQ_' + self.group.Matrix_id)
            var MatrixelemPosition1 = $(event).closest('.matrix-mobile-subQ-cont').nextAll('.matrix-mobile-subQ-cont')
          }
          if(this.questions.qtype == "RW" && !this.questions.isMatrixQuestion){
            var MDDelemPosition;
            MDDelemPosition = $(event).closest('.mdd-data_' + this.questions.group_no).nextAll('.mdd-data_' + this.questions.group_no)
          }
          if(this.questions.qtype == "RW" && !this.questions.isMatrixQuestion && MDDelemPosition.length > 0){
            MDDelemPosition = $(event).closest('.mdd-data_' + this.questions.group_no).nextAll('.mdd-data_' + this.questions.group_no).has('.question-data').eq(0).offset().top;
            $('html,body').animate({
              scrollTop: (MDDelemPosition - $(window).height() / 3)
            }, 400);
          }else if (this.questions.isMatrixQuestion && MatrixelemPosition.length > 0) {
            MatrixelemPosition = $(event).closest('.matrix-mobile-subQ_' + this.group.Matrix_id).nextAll('.matrix-mobile-subQ_' + this.group.Matrix_id).has('.question-data').eq(0).offset().top;
            //MatrixelemPosition = $(event).nextAll('.matrix-mobile-subQ_' + self.group.Matrix_id).has('.question-data').eq(0).offset().top;
            //MatrixelemPosition1 = $(event).closest('.matrix-mobile-subQ-cont').nextAll('.matrix-mobile-subQ-cont').has('.question-data').eq(0).offset().top;
            $('html,body').animate({
              scrollTop: (MatrixelemPosition - $(window).height() / 3)
            }, 400);
          } else if (this.questions.isMatrixQuestion && MatrixelemPosition1.length > 0) {
            //MatrixelemPosition = $(event).closest('.matrix-mobile-subQ_' + self.group.Matrix_id).nextAll('.matrix-mobile-subQ_' + self.group.Matrix_id).has('.question-data').eq(0).offset().top;
            //MatrixelemPosition = $(event).nextAll('.matrix-mobile-subQ_' + self.group.Matrix_id).has('.question-data').eq(0).offset().top;
            MatrixelemPosition1 = $(event).closest('.matrix-mobile-subQ-cont').nextAll('.matrix-mobile-subQ-cont').has('.question-data').eq(0).offset().top;
            $('html,body').animate({
              scrollTop: (MatrixelemPosition1 - $(window).height() / 3)
            }, 400);
          } else if (nextbtnLength > 0){
            nextbtnLength = $(event).closest('.active-ques').nextAll('.inactive-ques').has('.question-data').eq(0).offset().top;
            $('html,body').animate({
              scrollTop: (nextbtnLength - $(window).height() / 3)
            }, 400);
          }else{
            var scrollVal = $('.tblPageFooter').offset().top;
            $('html,body').animate({
              scrollTop: scrollVal
            }, 400);
          }
        } else {
          this.service.gotoNextQuestion(this.questions, event);
        }
        //this.service.gotoNextQuestion(this.questions,event);

      } else {
        $(event).closest('.main-ques-cont').find('.ques-response-btn-div').show();
      }
    }
    else if (this.service.surveyFormat == 3 && !this.isDemographics && this.questions.qtype != "RW") {
      var currElem = $('.active-ques');
      var nextElem = currElem.nextAll('.inactive-ques').has('.question-data').eq(0);
      var afterNextElem = currElem.nextAll('.inactive-ques').has('.question-data').eq(1);
      if (nextElem.length > 0) {
        $('.back-arrow').removeClass('disabled');
        this.service.hideQuestion(currElem[0]);
        let isHidden = $(nextElem).find(".question-data").attr("hidden");

        if (isHidden) {
          this.service.showQuestion(afterNextElem[0]);
        } else {
          this.service.showQuestion(nextElem[0]);
        }

        if (afterNextElem.length == 0 && $('.next-button').length == 0) {
          $('.next-arrow').addClass('disabled');
        }
      } else {
        if ($('.next-button').length != 0) {
          $('.next-button').trigger('click');
        }
      }
    }
  }

  gotoNextQuestion(question: Questions, event) {
    if (this.isStandAlone) {
      var nextbtnLength = $(event).closest('.active-ques').nextAll('.inactive-ques').has('.question-data').length;
      var MatrixelemPosition;
      MatrixelemPosition = $(event).closest('.matrix-mobile-subQ_' + this.group.Matrix_id).nextAll('.matrix-mobile-subQ_' + this.group.Matrix_id)
      //MatrixelemPosition = $(event).nextAll('.matrix-mobile-subQ_' + self.group.Matrix_id)
      var MatrixelemPosition1 = $(event).closest('.matrix-mobile-subQ-cont').nextAll('.matrix-mobile-subQ-cont')
      if (MatrixelemPosition.length > 0) {
        MatrixelemPosition = $(event).closest('.matrix-mobile-subQ_' + this.group.Matrix_id).nextAll('.matrix-mobile-subQ_' + this.group.Matrix_id).has('.question-data').eq(0).offset().top;
        //MatrixelemPosition = $(event).nextAll('.matrix-mobile-subQ_' + self.group.Matrix_id).has('.question-data').eq(0).offset().top;
        //MatrixelemPosition1 = $(event).closest('.matrix-mobile-subQ-cont').nextAll('.matrix-mobile-subQ-cont').has('.question-data').eq(0).offset().top;
        $('html,body').animate({
          scrollTop: (MatrixelemPosition - $(window).height() / 3)
        }, 400);
      } else if (MatrixelemPosition1.length > 0) {
        //MatrixelemPosition = $(event).closest('.matrix-mobile-subQ_' + self.group.Matrix_id).nextAll('.matrix-mobile-subQ_' + self.group.Matrix_id).has('.question-data').eq(0).offset().top;
        //MatrixelemPosition = $(event).nextAll('.matrix-mobile-subQ_' + self.group.Matrix_id).has('.question-data').eq(0).offset().top;
        MatrixelemPosition1 = $(event).closest('.matrix-mobile-subQ-cont').nextAll('.matrix-mobile-subQ-cont').has('.question-data').eq(0).offset().top;
        $('html,body').animate({
          scrollTop: (MatrixelemPosition1 - $(window).height() / 3)
        }, 400);
      } else if (nextbtnLength > 0){
        nextbtnLength = $(event).closest('.active-ques').nextAll('.inactive-ques').has('.question-data').eq(0).offset().top;
        $('html,body').animate({
          scrollTop: (nextbtnLength - $(window).height() / 3)
        }, 400);
      }else{
        var scrollVal = $('.tblPageFooter').offset().top;
        $('html,body').animate({
          scrollTop: scrollVal
        }, 400);
      }
    } else {
      this.service.gotoNextQuestion(this.questions, event);
    }
    //this.service.gotoNextQuestion(question, event);
  }

  closeDDList(event) {
    if(event.target.value !== "") {
      event.target.value = ""
    }
    $(event.target).closest('.drill-down-search').removeClass('showDrillList');
    $(event.target).attr("aria-expanded","false");
  }

  gotoNextQuestionKeyboard(question,event) {
    event.preventDefault();
    this.gotoNextQuestion(question,event.target);
  }

  onBlurMethod() {
    if (this.questions.otherAnswer == "") {
      this.questions.otherAnswer = null;
    }
    this.UpdateQuestionsData(this.questions);
  }
}
